import http from "axiosSetup";

export interface CheckoutResponse {
  checkoutUrl: string;
}

class CheckoutService {
  static async createAdvanceCheckout(): Promise<CheckoutResponse> {
    return http.post<CheckoutResponse>("/checkouts/advance").then((response) => response.data);
  }

  static async createSensorCheckout(): Promise<CheckoutResponse> {
    return http.post<CheckoutResponse>("/checkouts/sensor").then((response) => response.data);
  }
}

export default CheckoutService;
